export class Automationaction {
    actionId: string;
    automationId: string; // ID of the associated automation
    name: string; // Name of the action
    description?: string; // Optional description of the action
    organizationId: string; // ID of the organization this action belongs to
    projectId?: string; // Optional ID of the project this action belongs to
    type: string = 'choose'; // Type of action, e.g., 'notification', 'update', 'delete'
    sortOrder?: number; // Optional sort order for the action
    status: string; // Status of the action, e.g., 'active', 'inactive'
    entityId: string; // ID of the entity this action is associated with
    created?: string; // ISO date string for when the action was created
    createdby?: string; // ID of the source from which this action was created
    fields?: {
    [key: string]: {
      value: string;
      fieldType: 'Value' | 'Reference' | 'Template';
    };
  };
}
